import { Component, Input } from '@angular/core';
import { FitMedProfile } from '@app/shared/models/data/fit-med-profile/FitMedProfile';
import { ProfilePictureComponent } from '../profile-picture.component';


@Component({
    selector: 'app-profile-picture-with-alerts',
    templateUrl: './profile-picture-with-alerts.component.html',
    styleUrls: ['./profile-picture-with-alerts.component.scss'],
    standalone: true,
    imports: [ProfilePictureComponent]
})
export class ProfilePictureWithAlertsComponent {
  @Input() fitMedProfile: FitMedProfile;
  @Input() class: string;

  @Input() alertText: string = null;
  @Input() alertColour: string = null;

  constructor() {
  }
}
